import { post } from './api';

/**
 * Record a stock purchase
 */
export async function recordStockPurchase({
  userWalletAddress,
  tokenAddress,
  stockSymbol,
  stockName,
  amount,
  price,
  value,
  txSignature,
}) {
  return post('/stocks/purchases', {
    userWalletAddress,
    tokenAddress,
    stockSymbol,
    stockName,
    amount,
    price,
    value,
    txSignature,
  });
}

/**
 * Record a stock sale
 */
export async function recordStockSale({
  userWalletAddress,
  tokenAddress,
  stockSymbol,
  stockName,
  amount,
  price,
  value,
  txSignature,
}) {
  return post('/stocks/sales', {
    userWalletAddress,
    tokenAddress,
    stockSymbol,
    stockName,
    amount,
    price,
    value,
    txSignature,
  });
}
